<div
  (click)="closeDropdown()"
  class="bg-border-subtle fixed top-0 left-0 z-50 inline-flex w-full items-center justify-between gap-10 px-[24px] py-[8px] shadow-md">
  <a routerLink="/admin" class="inline-flex flex-col items-center justify-start gap-[5px]">
    <h1
      class="logo-text text-primary text-3xl leading-none drop-shadow-lg"
      [ngClass]="{ 'logo-text-ar': currentLocale() == 'ar' }">
      {{ currentLocale() == "ar" ? "فارما" : "PHARMA" }}
    </h1>
  </a>

  <div class="flex items-center justify-start gap-4">
    <button
      (click)="toggleLanguage()"
      class="border-primary text-primary hover-border-primary hover-bg-primary flex h-9 cursor-pointer items-center justify-center gap-2 rounded-lg border-2 bg-white px-4 py-2 transition-all hover:text-white active:scale-95">
      <svg class="h-4 w-4 transition-colors" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path d="M2 12H22" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22C9.49872 19.2616 8.07725 15.708 8 12C8.07725 8.29203 9.49872 4.73835 12 2Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
      <span class="font-['Inter'] text-sm font-medium whitespace-nowrap transition-colors">
        {{ currentLocale() == "en" ? "العربية" : "English" }}
      </span>
    </button>

    <div class="notifications-container relative flex items-center justify-center gap-2">
      <div
        (click)="onNotificationsClick($event)"
        class="relative h-7 w-7 cursor-pointer overflow-hidden transition-transform hover:scale-110 active:scale-95">
        @if (!hasUnreadNotifications()) {
          <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 24 24">
            <path
              class="fill-primary"
              d="M10 21h4c0 1.1-.9 2-2 2s-2-.9-2-2m11-2v1H3v-1l2-2v-6c0-3.1 2-5.8 5-6.7V4c0-1.1.9-2 2-2s2 .9 2 2v.3c3 .9 5 3.6 5 6.7v6zm-4-8c0-2.8-2.2-5-5-5s-5 2.2-5 5v7h10z" />
          </svg>
        } @else {
          <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 24 24">
            <path
              class="fill-primary"
              d="M19 17v-5.2c-.5.1-1 .2-1.5.2H17v6H7v-7c0-2.8 2.2-5 5-5c.1-1.3.7-2.4 1.5-3.3c-.3-.4-.9-.7-1.5-.7c-1.1 0-2 .9-2 2v.3C7 5.2 5 7.9 5 11v6l-2 2v1h18v-1zm-9 4c0 1.1.9 2 2 2s2-.9 2-2zM21 6.5c0 1.9-1.6 3.5-3.5 3.5S14 8.4 14 6.5S15.6 3 17.5 3S21 4.6 21 6.5" />
          </svg>
        }
      </div>
      <app-notifications-dropdown [isOpen]="isNotificationsDropdownOpen()" (closeRequested)="onNotificationsClose()" />
    </div>

    <div class="relative" (click)="$event.stopPropagation()">
      <div
        (click)="toggleDropdown($event)"
        class="bg-primary hover-bg-primary-hover flex h-8 w-8 cursor-pointer items-center justify-center rounded-full font-['Inter'] text-sm font-semibold text-white transition-all active:scale-95">
        {{ userInitial() }}
      </div>

      @if (isDropdownOpen()) {
        <div
          class="absolute top-11 z-50 min-w-[175px] overflow-hidden rounded-lg border border-gray-200 bg-white shadow-xl ltr:right-0 rtl:left-0">
          <button
            (click)="onProfile()"
            class="hover-bg-primary w-full px-3 py-2 font-['Inter'] text-xs font-medium text-neutral-800 transition-colors hover:cursor-pointer hover:text-white ltr:text-left rtl:text-right">
            <span i18n="@@headerUpdateProfile">Profile</span>
          </button>
          <div class="border-t border-gray-200"></div>
          <button
            (click)="onLogout()"
            class="hover-bg-primary w-full px-3 py-2 font-['Inter'] text-xs font-medium text-neutral-800 transition-colors hover:cursor-pointer hover:text-white ltr:text-left rtl:text-right">
            <span i18n="@@headerLogout">Logout</span>
          </button>
        </div>
      }
    </div>
  </div>
</div>
